import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import ExpertProductApi from "../../../api/ExpertProductApi";

function CardExpertProduct() {

    const [expertProducts, setExpertProducts] = useState([]);

    useEffect(() => {
        ExpertProductApi.getExpertProducts({status: 'A'}).then(data => {
            setExpertProducts(data.products);
        });
    }, []);

    useEffect(() => {
        let swiper = null;
        const initSwiper = () => {
            const isPC = window.matchMedia("(min-width: 768px)").matches;
            console.log('isPC', isPC, swiper);
            if (isPC && !swiper) {
                swiper = new window.Swiper(".vertify-card-slide .swiper-container", {
                    slidesPerView: 'auto',
                    spaceBetween: 0,
                    loop: true,
                    navigation: {
                        nextEl: ".vertify-card-slide .swiper-button-next",
                        prevEl: ".vertify-card-slide .swiper-button-prev",
                    },
                });
            } 
            
            if (!isPC && swiper) {
                swiper.destroy(true, true);
                swiper = null;
            }
        };

        initSwiper();
        window.addEventListener("resize", initSwiper);
        
        // event destroy
        return () => {
            window.removeEventListener("resize", initSwiper);
            if (swiper) {
                swiper.destroy(true, true);
            }
        };
    });

    return (
        <div class="section-area">
            <div class="section-header section-header-mo">
                <div class="section-title"><h5>전문가 서비스</h5></div>
                <Link to={`/expert`} title="더보기">
                    <span class="pc-only">더보기</span>
                    <i class="icon icon-arrow-right-bold"></i>
                </Link>
            </div>
            <div class="section-content">
                <div class="vertify-card-slide">
                    <div class="swiper-container">
                        <div class="swiper-wrapper">

                            {expertProducts.map((product) => (
                                <div class="swiper-slide">
                                    <Link to={"/expert/product/" + product.expert_product_id} className="vertify-card">
                                        <div class="vertify-card-thumb">
                                            <img src={product.expert_product_banner_img || "/static/img/assets/thumb_adv.png"} />
                                        </div>
                                        <div class="vertify-card-desc">
                                            <div class="vertify-card-meta">
                                                <span>{product.user_nicknm}</span>
                                                {/* <i class="icon icon-medal"></i> */}

                                                <div class="vertify-card-etc">
                                                    <i class="icon icon-heart-fill"></i>
                                                    <span>{product.expert_product_like_cnt}</span>
                                                </div>
                                            </div>
                                            <h1>{product.expert_product_title}</h1>
                                            <div class="vertify-card-price">
                                                <p>{product.min_service_price?.toLocaleString()}원~</p>
                                            </div>

                                            <span class="vertify-card-badge">종합대행</span>
                                        </div>
                                    </Link>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div class="swiper-button swiper-button-prev"></div>
                    <div class="swiper-button swiper-button-next"></div>
                </div>
            </div>
        </div>
    )
}

export default CardExpertProduct;